import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { paths } from "../../router";
import ExternalLink from "../Navigation/Links/ExternalLink";
import Link from "../Navigation/Links/Link";
import LicenseCard from "../Ui/LicenseCard";

const FORECAST_USER_GUIDE_URL = 'https://confluence.ecmwf.int/display/FUG/1+Introduction';

const OrderTypeSelector = () => {
  return (
    <Row>
      <Col lg={6} xl={4} className="margin-bottom-sm">
        <LicenseCard
          title="Real-time data"
          action={
            <Button as={Link} to={paths.realtimeOrderNew} block>
              Configure
            </Button>
          }
        >
          <p>
            Browse the catalogue of ECMWF real-time products. ECMWF real-time products show how the weather is most
            likely to evolve.
            The Catalogue outlines the real-time meteorological and oceanographic products available from the ECMWF
            forecasting system for use by licence holders.
          </p>

          <p>
            Users are expected to have a background knowledge of atmospheric or oceanographic sciences,
            and are encouraged to consult the <ExternalLink
            url={FORECAST_USER_GUIDE_URL}>ECMWF Forecast User Guide</ExternalLink>.
          </p>

          <p>
            The majority of the data are delivered in GRIB1 or GRIB2 format, unless otherwise specified.
          </p>
        </LicenseCard>
      </Col>

      <Col lg={6} xl={4} className="margin-bottom-sm">
        <LicenseCard
          title="Archive licence"
          action={
            <Button as={Link} to={paths.archiveOrderNew} block>
              Order
            </Button>
          }
        >
          <p>
            Our Meteorological Archival and Retrieval System (MARS) enables you to list and retrieve meteorological data
            in GRIB/NetCDF via the Web API service (supported Python client software) and web interfaces where you can
            explore the parts of the archive available to you and get the MARS request syntax/scripts to download data
            via the web API. Members and licence holders can also check availability of the data and estimate the
            download size.
          </p>

          <p>
            If you are a (future) user from within a Member or Co-operating State and are conducting non-commercial
            research, please contact a <ExternalLink url="https://www.ecmwf.int/en/about/contact-us/computing-representatives">
            Computing Representative from your country</ExternalLink>. All other users can order an
            Archive licence with ECMWF via the button below.
          </p>
        </LicenseCard>
      </Col>

      <Col lg={6} xl={4} className="margin-bottom-sm">
        <LicenseCard
          title="Web licence (ecCharts)"
          action={
            <Button as={Link} to={paths.webOrderNew} block>
              Order
            </Button>
          }
        >
          <p>
            This licence provides access to ecCharts, which is ECMWF&apos;s interactive interface for visualising ECMWF
            real-time data (note: no raw data is accessible from this interface).
          </p>

          <p>
            Please note that access to all web products is provided on an &lsquo;as is&rsquo; basis.
            The product range is adjusted in the light of experience and in response to the evolution
            of the forecasting system; newly developed products are added,
            but others may be discontinued, at the discretion of ECMWF.
          </p>
        </LicenseCard>
      </Col>
    </Row>
  )
}

export default OrderTypeSelector;
